// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import fastclick from 'fastclick'
import "./common/css/commonBase.css"
import 'vue-layer-mobile/need/layer.css'
import layer from 'vue-layer-mobile'
import clipper from './common/js/clipper.js'
import 'jquery'

Vue.use(layer)
Vue.use(clipper)
Vue.use(ElementUI)

fastclick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
  	router,
 	render: h => h(App),
  	data: {
	    eventHub: new Vue(),
	    authorList:'',
	    user:''
	}
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js